const routes = [
  {
    path: 'compencapsulation',
    name: 'compencapsulation',
    component: () => import(/* webpackChunkName: "compencapsulation" */ '@/modules/compencapsulation/index.vue')
  },
];

export default routes;